/**
 * Capitalizes the first letter of a string
 * @param str - The string to capitalize
 * @returns The string with the first letter capitalized, or the original value if it's not a string or is empty
 */
export default function capitalizeFirstLetter(str: string | null | undefined): string {
  if (!str || typeof str !== 'string' || str.length === 0) {
    return str || '';
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}

